var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 34.5L18.7 31.3L15.1 30.5L15.45 26.8L13 24L15.45 21.2L15.1 17.5L18.7 16.7L20.6 13.5L24 14.95L27.4 13.5L29.3 16.7L32.9 17.5L32.55 21.2L35 24L32.55 26.8L32.9 30.5L29.3 31.3L27.4 34.5L24 33.05L20.6 34.5ZM22.95 27.55L28.6 21.9L27.2 20.45L22.95 24.7L20.8 22.6L19.4 24L22.95 27.55Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletionIcon);
export default __webpack_public_path__ + "static/media/completionIcon.6e8706ebf440665a84accd8df1d2a755.svg";
export { ForwardRef as ReactComponent };